<template>
  <PageWrap>
    <Error404 :error="{ statusCode: 404 }" v-if="error" />
    <template v-else>
      <HeadSeo :data="data" />
      <HeaderOther :h1="data?.title" />
      <main>
        <UiBreadCrumbs
          :data="[
            {
              title: 'Новости',
              path: '/news',
            },
            {
              title: data?.title,
            },
          ]"
        />
        <BlockPageText :html="data?.text" />
        <BlockGallery
          :name="`news-${data.id}`"
          :data="data?.gallery"
          h2="Фото/видео-галерея"
          v-if="data?.gallery"
        />
        <BlockWhyWe />
        <BlockContact />
      </main>
    </template>
    <BlockFoot />
  </PageWrap>
</template>

<script setup>
const { url } = useRoute().params;
const { data, error } = await useFetch(`/api/news.post?url=${url}`);
if (error.value) {
  const event = useRequestEvent();
  setResponseStatus(event, 404, "Page Not Found");
}
</script>
